import React, { useEffect, useMemo, useState } from 'react'
import { colors } from '../../../Shared/colors';
import styled from 'styled-components';
import { useGetAllProjectsQuery } from '../../../features/projectSlice';
import { decryptData } from '../../../services/crypto';
import { Autocomplete, Box, TextField } from '@mui/material';
import { useGetSingleHierarchyQuery, useGetActiveStaffQuery } from '../../../features/employeeSlice';
import { useGetAllClientsQuery } from '../../../features/clientSlice';
import toast, { Toaster } from 'react-hot-toast';
import { SharedLeadsDataTable } from './SharedLeadsDataTable';
import { useLazyGetSharedLeadsQuery } from '../../../features/leadsSlice';
import { usePaginationFromURL } from '../../../hooks/usePaginationFromURL';

export const SharedLeadsFirst = () => {
    const defaultClientOption = { id: "", label: "select" };

    let staffName = null;
    let storedStaffName = localStorage.getItem("staffName");

    if (storedStaffName) {
        try {
            staffName = decryptData(storedStaffName);
        } catch (error) {
            console.error("Failed to decrypt data:", error);
        }
    }

    let staffId = null;
    let storedStaffId = localStorage.getItem("id");

    if (storedStaffId) {
        try {
            staffId = decryptData(storedStaffId);
        } catch (error) {
            console.error("Failed to decrypt data:", error);
        }
    }

    let role = null;
    let storedStaffRole = localStorage.getItem("role");

    if (storedStaffRole) {
        try {
            role = decryptData(storedStaffRole);
        } catch (error) {
            console.error("Failed to decrypt data:", error);
        }
    }
    const [kpiData, setkpiData] = useState({
        clientID: defaultClientOption,
        leadID: "",
        employeeId: { id: staffId, label: staffName },
        project: "",
        clientPhone: "",
        source: ""
    });
    const [searchFilters, setSearchFilters] = useState({
        clientID: defaultClientOption,
        leadID: "",
        employeeId: staffId,
        project: "",
        clientPhone: "",
        source: ""
    });
    // Use URL-based pagination hook (Note: DataGrid uses 0-indexed pages, but we'll convert)
    const { currentPage: urlPage, pageSize, setPage: setUrlPage, setPageSize } = usePaginationFromURL({
      defaultPage: 1,
      defaultPageSize: 50
    });
    // Convert to 0-indexed for DataGrid
    const page = urlPage - 1;
    const setPage = (pageNum) => {
      // Accept both 0-indexed (from DataGrid) and 1-indexed values
      const p = typeof pageNum === 'function' ? pageNum(page) : pageNum;
      setUrlPage(p >= 0 ? p + 1 : 1);
    };
    const { data: project } = useGetAllProjectsQuery();
    const { data: staff } = useGetActiveStaffQuery();
    const { data: hierarchyStaff } = useGetSingleHierarchyQuery({ staffId });
    const { data: clients, isFetching: isClientFetcing, isLoading: isClientLoading } = useGetAllClientsQuery({ employeeId: kpiData?.employeeId?.id });
    // const { data: leads, isFetching } = useGetSharedLeadsQuery({
    //     page: page + 1,
    //     limit: pageSize,
    // });
    // const [trigger, { data: ShareleadData, isFetching, error }] =
    //     useGetSharedLeadsQuery();
    // console.log(ShareleadData, "share data ")

    const [trigger, { data: ShareleadData, isFetching }] = useLazyGetSharedLeadsQuery();

    const staffOptions = useMemo(() => {
        let options = [];
        hierarchyStaff?.map((staff) =>
            options.push({
                id: staff?._id,
                label: staff?.firstName + " " + staff?.lastName,
            })
        );

        return options;
    }, [hierarchyStaff]);

    const allStaffOptions = useMemo(() => {
        let options = [];
        staff?.map((staff) =>
            options.push({
                id: staff?._id,
                label: staff?.firstName + " " + staff?.lastName,
            })
        );

        return options;
    }, [staff]);

    // const clientOptions = useMemo(() => {
    //     let options = [{ id: "", label: "select" }];
    //     clients?.LoginEmployeeClients.map((client) =>
    //         options.push({
    //             id: client?._id,
    //             label: client?.fullName,
    //         })
    //     );
    //     return options;

    // }, [clients]);
    const clientOptions = useMemo(() => {
        const options = [{ id: "", label: "select" }];

        if (ShareleadData?.leadSharingData?.length > 0) {
            ShareleadData.leadSharingData.forEach((lead) => {
                options.push({
                    id: lead.clientID,
                    label: lead.clientName,
                });
            });

            const uniqueOptions = Array.from(
                new Map(options.map(item => [item.id, item])).values()
            );
            return uniqueOptions;
        }

        return options;
    }, [ShareleadData]);


    const handleChange = (e) => {
        const { name } = e.target;
        let { value } = e.target;

        if (name === "clientPhone" || name === "leadID") {
            value = `${value ?? ""}`.replace(/\D/g, "");
        }

        setkpiData({
            ...kpiData,
            [name]: value,
        });
    };

    // const handleSearch = () => {
    //     const {
    //         project,
    //         source,
    //         leadID,
    //         clientID,
    //         clientPhone,
    //     } = kpiData;

    //     let employeeId =
    //         role === "ceo" || role === "admin" || role === "sbdm" || role === "bdm" || role === "account"
    //             ? kpiData.employeeID?.id || staffId
    //             : kpiData.employeeID?.id;

    //     const payload = {
    //         page,
    //         limit: pageSize,
    //         employeeId,
    //         clientID: clientID?.id || "",
    //         project,
    //         clientPhone,
    //         leadID,
    //         source,
    //     };

    //     trigger(payload)
    //         .then(() => toast.success("Leads loaded successfully!"))
    //         .catch((err) => {
    //             console.error(err);
    //             toast.error(err?.data?.error?.message || "Failed to load leads");
    //         });

    //     setSearchFilters({
    //         clientID,
    //         project,
    //         employeeID: employeeId,
    //         clientPhone,
    //         leadID,
    //         source,
    //     });
    // };


    const handleSearch = () => {
        const {
            project,
            source,
            leadID,
            clientID,
            clientPhone,
        } = kpiData;

        let employeeId =
            ["ceo", "admin", "sbdm", "bdm", "account"].includes(role)
                ? kpiData?.employeeId?.id || staffId
                : kpiData?.employeeId?.id;

        const payload = {
            page: page + 1,
            limit: pageSize,
            employeeId,
            clientID: clientID?.id || "",
            project,
            clientPhone,
            leadID,
            source,
        };

        trigger(payload)
            .then(() => toast.success("Leads loaded successfully!"))
            .catch((err) => toast.error(err?.data?.error?.message || "Failed to load leads."));

        setSearchFilters({
            clientID,
            project,
            employeeId: employeeId || staffId,
            clientPhone,
            leadID,
            source,
        });
    };


    useEffect(() => {
        const {
            project,
            source,
            leadID,
            employeeId,
            clientID,
            clientPhone,
        } = searchFilters;

        trigger({
            project,
            employeeId,
            clientID: clientID?.id || "",
            clientPhone,
            source,
            leadID,
            page: page + 1,
            limit: pageSize,
        });
    }, [page, pageSize, searchFilters]);



    return (
        <>
            <Main>
                <Search>
                    <HeaderSection>
                        <HeaderIcon>🔍</HeaderIcon>
                        <HeaderContent>
                            <HeaderTitle>Search Shared Leads</HeaderTitle>
                            <HeaderSubtitle>Filter and find shared leads efficiently</HeaderSubtitle>
                        </HeaderContent>
                    </HeaderSection>
                    
                    <FilterGrid>
                        <FilterRow>
                            <FilterField>
                                <FieldLabel>PHONE NUMBER</FieldLabel>
                                <InputContainer>
                                    <input
                                        type="tel"
                                        name="clientPhone"
                                        id="clientPhone"
                                        value={kpiData.clientPhone}
                                        onChange={handleChange}
                                        placeholder="Enter phone number"
                                    />
                                </InputContainer>
                            </FilterField>
                            
                            <FilterField>
                                <FieldLabel>LEAD ID</FieldLabel>
                                <InputContainer>
                                    <input
                                        type="text"
                                        name="leadID"
                                        id="lead"
                                        value={kpiData.leadID}
                                        onChange={handleChange}
                                        placeholder="Enter Lead ID"
                                    />
                                </InputContainer>
                            </FilterField>
                            
                            <FilterField>
                                <FieldLabel>PROJECT</FieldLabel>
                                <SelectContainer>
                                    <StyledSelect
                                        name="project"
                                        id="project"
                                        value={kpiData.project}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Project</option>
                                        {project?.map((proj) => (
                                            <option key={proj._id} value={proj._id}>{proj.projectName}</option>
                                        ))}
                                    </StyledSelect>
                                    <SelectIcon>▼</SelectIcon>
                                </SelectContainer>
                            </FilterField>
                            
                            <FilterField>
                                <FieldLabel>SOURCE</FieldLabel>
                                <SelectContainer>
                                    <StyledSelect
                                        name="source"
                                        id="source"
                                        value={kpiData.source}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Source</option>
                                        <option value="walkIn">Walk In</option>
                                        <option value="Facebook">Facebook</option>
                                        <option value="instagram">Instagram</option>
                                        <option value="Refrence">Reference</option>
                                        <option value="billboards">Bill Board</option>
                                    </StyledSelect>
                                    <SelectIcon>▼</SelectIcon>
                                </SelectContainer>
                            </FilterField>
                        </FilterRow>
                        
                        <FilterRow>
                            {role === "ceo" ||
                                role === "admin" ||
                                role === "sbdm" ||
                                role === "account" ||
                                role === "bdm" ? (
                                <FilterField>
                                    <FieldLabel>STAFF</FieldLabel>
                                    <Autocomplete
                                        id="staff-autocomplete"
                                        size="small"
                                        options={
                                            role === "ceo" || role === "admin" || role === "account"
                                                ? allStaffOptions
                                                : staffOptions
                                        }
                                        getOptionLabel={(option) => option.label}
                                        style={{
                                            width: "100%",
                                            borderRadius: "8px",
                                            minHeight: "40px",
                                            border: `1px solid ${colors.inputBorderWhite}`,
                                        }}
                                        onChange={(e, value) => {
                                            setkpiData({
                                                ...kpiData,
                                                employeeId: value || { id: staffId, label: staffName },
                                                clientID: defaultClientOption
                                            });
                                        }}
                                        value={kpiData.employeeId}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="standard"
                                                placeholder="Select Staff"
                                                sx={{
                                                    backgroundColor: `${colors.white}`,
                                                    paddingTop: "1em",
                                                }}
                                            />
                                        )}
                                    />
                                </FilterField>
                            ) : null}
                            
                            <FilterField>
                                <FieldLabel>CLIENT</FieldLabel>
                                <Autocomplete
                                    id="client-autocomplete"
                                    size="small"
                                    disabled={isClientLoading || isClientFetcing}
                                    options={clientOptions}
                                    getOptionLabel={(option) => option.label}
                                    style={{
                                        width: "100%",
                                        borderRadius: "8px",
                                        minHeight: "40px",
                                        overflow: "hidden",
                                        border: `1px solid ${colors.inputBorderWhite}`,
                                    }}
                                    onChange={(e, value) => {
                                        setkpiData({ ...kpiData, clientID: value || defaultClientOption });
                                    }}
                                    value={kpiData.clientID || defaultClientOption}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            placeholder="Select Client"
                                            sx={{
                                                backgroundColor: `${colors.white}`,
                                                paddingTop: "1em",
                                            }}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <Box component="li" {...props} key={option.id}>
                                            {option.label}
                                        </Box>
                                    )}
                                />
                            </FilterField>
                            
                            <FilterField>
                                <SearchButton
                                    onClick={handleSearch}
                                    disabled={isFetching}
                                >
                                    {isFetching ? (
                                        <>
                                            <LoadingSpinner />
                                            Searching...
                                        </>
                                    ) : (
                                        <>
                                            🔍 Search Leads
                                        </>
                                    )}
                                </SearchButton>
                            </FilterField>
                        </FilterRow>
                    </FilterGrid>
                </Search>
            </Main>
            <Toaster />
            <SharedLeadsDataTable
                leads={ShareleadData}
                pageSize={pageSize}
                setPageSize={setPageSize}
                setPage={setPage}
                isFetching={isFetching}
                currentPage={page}
                totalPages={Math.ceil(ShareleadData?.total / pageSize)}
            />
        </>
    )
}





const Main = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background: ${colors.white};
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    z-index: 1;
  }
`;

const Search = styled.div`
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
  width: 100%;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`;

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const HeaderIcon = styled.div`
  font-size: 2rem;
  color: ${colors.brown};
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const HeaderTitle = styled.h2`
  color: ${colors.text};
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
`;

const HeaderSubtitle = styled.p`
  color: ${colors.textMed};
  font-size: 0.95rem;
  margin: 0;
  font-weight: 400;
`;

const FilterGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const FilterRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  align-items: end;
  margin-bottom: 1.5rem;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }
  
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
  }
  
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 0;
`;

const FieldLabel = styled.label`
  color: ${colors.text};
  font-size: 0.8rem;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.2;
`;

const InputContainer = styled.div`
  position: relative;
  border: 1px solid ${colors.inputBorderWhite};
  border-radius: 8px;
  background-color: ${colors.white};
  transition: all 0.2s ease;
  min-height: 40px;
  display: flex;
  align-items: center;
  
  &:hover {
    border-color: ${colors.brown};
  }
  
  &:focus-within {
    border-color: ${colors.brown};
    box-shadow: 0 0 0 2px rgba(36, 147, 147, 0.1);
  }

  input {
    background-color: transparent;
    width: 100%;
    padding: 0.75rem 1rem;
    outline: none;
    border: none;
    font-size: 0.875rem;
    color: ${colors.text};
    height: 100%;
    
    &::placeholder {
      color: ${colors.textMed};
    }
  }
`;

const SelectContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid ${colors.inputBorderWhite};
  border-radius: 8px;
  background-color: ${colors.white};
  transition: all 0.2s ease;
  overflow: hidden;
  min-height: 40px;
  
  &:hover {
    border-color: ${colors.brown};
  }
  
  &:focus-within {
    border-color: ${colors.brown};
    box-shadow: 0 0 0 2px rgba(36, 147, 147, 0.1);
  }
`;

const StyledSelect = styled.select`
  width: 100%;
  padding: 0.75rem 2.5rem 0.75rem 1rem;
  border: none;
  outline: none;
  background-color: transparent;
  font-size: 0.875rem;
  color: ${colors.text};
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  
  option {
    padding: 0.5rem;
    background-color: ${colors.white};
    color: ${colors.text};
    
    &:hover {
      background-color: ${colors.lightWhite};
    }
  }
  
  &:focus {
    outline: none;
  }
`;

const SelectIcon = styled.span`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: ${colors.textMed};
  font-size: 0.75rem;
  pointer-events: none;
  transition: all 0.2s ease;
  
  ${SelectContainer}:hover & {
    color: ${colors.brown};
  }
  
  ${SelectContainer}:focus-within & {
    color: ${colors.brown};
    transform: translateY(-50%) rotate(180deg);
  }
`;

const SearchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: ${colors.white};
  background: ${(props) =>
    props.disabled 
      ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)' 
      : `linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%)`};
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  min-width: 140px;
  height: 40px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: ${(props) => 
    props.disabled 
      ? '0 2px 4px rgba(0, 0, 0, 0.1)' 
      : '0 4px 12px rgba(36, 147, 147, 0.3)'};
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(36, 147, 147, 0.4);
    background: linear-gradient(135deg, #1a6b6b 0%, ${colors.brown} 100%);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid ${colors.white};
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
